import { render } from "./YanfeiLiu.vue?vue&type=template&id=f01044dc"
const script = {}

import "./YanfeiLiu.vue?vue&type=style&index=0&id=f01044dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__